module.exports = Mustache;


//////////////////
// WEBPACK FOOTER
// external "Mustache"
// module id = 784
// module chunks = 2